module.exports = __webpack_public_path__ + "static/media/g4.66a27e40.jpg";